import React, { useState } from 'react'
import VideoGalleryCategoryController from '../controller/VideoGalleryCategoryController';

function VideoGalleryCategoryList({ ...props }) {

    const { categories, setCategories, handleDelete, isLoading } = VideoGalleryCategoryController()



    return (
        <div>
            {isLoading && "Loading..."}
            {!isLoading && (
                <table id="example1" className="table cms-video-gallery-category-list mb-0">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>featured</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories?.map((item) => (
                            <tr
                                key={item.id}
                                className={item.id}
                            >
                                <td>
                                    <p>
                                        {item.title}
                                    </p>
                                </td>
                                <td>
                                    {item.is_featured ? <>
                                        <i className="fa fa-check"></i>
                                    </> : <>
                                        <i className="fa fa-remove font-color-gray"></i>
                                    </>}
                                </td>
                                <td>
                                    <div className="btn-group">
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                if (
                                                    window.confirm(
                                                        "Are you sure you wish to delete this item?"
                                                    )
                                                )
                                                    handleDelete(e, item.id);
                                            }}
                                            className="btn btn-default btn-sm"
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                        <a
                                            href="#edit"
                                            onClick={(e) => { handleDelete(e, item.id) }}
                                            className="btn btn-default btn-sm"
                                        >
                                            <i className="fa fa-edit"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

        </div>
    )
}

export default VideoGalleryCategoryList